import axios from 'axios';
import useSWR from 'swr';
import { UserSubscription } from '@/app/_lib/interfaces';

export const getUserSubscriptionKey = (userId?: string) => {
  return `/api/user/subscription-${userId}`;
};

export const useUserSubscriptionFetcher = (
  userId: string,
  disabled: boolean
) => {
  return useSWR(disabled ? null : getUserSubscriptionKey(userId), () =>
    axios
      .get(`/api/user/subscription`)
      .then(({ data }) => data as UserSubscription)
  );
};
